module.exports = __webpack_public_path__ + "static/media/ParthPatelWhyMe.f5f0b08b.m4v";